import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { EnrollmentService } from '@shared/services/enrollment.service';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@shared/services/auth.service';
import { SessionService } from '../../shared/services/session.service';
import { FacultySearchResultDialogComponent } from '../faculty-search-result-dialog/faculty-search-result-dialog.component';
import { NewFacultyDialogComponent } from '../new-faculty-dialog/new-faculty-dialog.component';

@Component({
  selector: 'aaos-faculty-search-dialog',
  templateUrl: './faculty-search-dialog.component.html',
  styleUrls: ['./faculty-search-dialog.component.scss']
})
export class FacultySearchDialogComponent implements OnInit {

    formGroup: FormGroup;
    firstNameControl = 'firstName';
    lastNameControl = 'lastName';
    primaryEmailControl = 'primaryEmail';
    editPrivileges = false;
    loading = false;
    possibleFaculty: any;
    selectedFaculty: any;
    searchResponse: any;

    constructor(private enrollmentService: EnrollmentService, private dialog: MatDialog, private authService: AuthService,
    public searchDialogRef: MatDialogRef<FacultySearchDialogComponent>, private sessionService: SessionService
  ) {
    this.enrollmentService.rosterChange.subscribe(() => {
        this.dialog.closeAll();
      });
    }

  ngOnInit(): void {
    this.createFormGroup();
    this.editPrivileges = this.authService.changeAuthorized();
  }

    createFormGroup() {
    this.formGroup = new FormGroup({
      firstName: new FormControl(''),
      lastName: new FormControl(''),
      primaryEmail: new FormControl('')
    });
  }

  public canAddResident(): boolean {
    return (!this.formGroup.valid || !this.editPrivileges);
  }

  openResultsDialog() {
        const resultsDialogRef = this.dialog.open(FacultySearchResultDialogComponent, this.getSearchResultsModalConfig());
        this.loading = false;
        resultsDialogRef.componentInstance.actionTaken.subscribe( selection => {
          this.selectedFaculty = selection;
          if (this.selectedFaculty != null) {
             this.dialog.open(NewFacultyDialogComponent, this.getAddFromSearchModalConfig());
          }
        });
  }

  onSubmit() {
    this.loading = true;
    this.enrollmentService.searchFaculty(
        this.formGroup.controls[this.lastNameControl].value,
        this.formGroup.controls[this.firstNameControl].value,
        this.formGroup.controls[this.primaryEmailControl].value,
        this.sessionService.getInstitutionId(),
        40)
        .subscribe(results => {
      this.possibleFaculty = results.contacts;
      this.searchResponse = results;
      this.openResultsDialog();
      this.loading = false;
    });
  }

  getAddFromSearchModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: this.selectedFaculty,
    } as MatDialogConfig;
  }

  getSearchResultsModalConfig() {
    return {
      panelClass: 'wide-dialog',
      disableClose: true,
      autoFocus: false,
      data: this.searchResponse,
    } as MatDialogConfig;
  }

  canAddFaculty(): boolean {
    return (!this.formGroup.valid || !this.editPrivileges);
  }

  closeDialog() {
    this.searchDialogRef.close();
  }

    invalidRequiredField(fieldName: string): boolean {
    if (this.formGroup.get(fieldName).hasError('required')) {
      return true;
    }
    return false;
  }

}
